import { StyleSheet } from 'aphrodite';
import { SPACE } from '../../web/components-v2/Theme/theme';
import tysonBackgroundImage from '../assets/tyson-background.png';
import { brandPrimaryDark, titles, warningDark } from '../styles/colors';

export const styleSheet = StyleSheet.create({
	noCoffee: {
		background: warningDark,
		color: titles,
		padding: SPACE[20],
		position: 'absolute',
		top: 105,
		width: '100vw',
		zIndex: 1000,
	},
	subBar: {
		alignItems: 'center',
		background: brandPrimaryDark,
		display: 'flex',
		width: '100%',
	},
	tysonBackground: {
		backgroundColor: `#22D363`,
		backgroundImage: `url("${tysonBackgroundImage}")`,
		backgroundPosition: 'center top',
		backgroundRepeat: 'repeat-x',
		backgroundSize: 'contain',
	},
});
